

// path sample: http://localhost:8080/main/vehicle/0/overview/dashboard
export const VEHICLE_ROUTES = [
  {
    path: "new",
    name: "vehicleNew",
    component: () =>
        import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/VehicleNewLayout")
  },
  {
    path: "overview",
    name: "vehicleOverview",
    component: () =>
        import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/VehicleOverview"),
    children: [
      {
        path: "dashboard",
        name: "vehicleDashboard",
        component: () =>
            import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/overview/Dashboard")
      },
      {
        path: "autoEye",
        name: "autoEye",
        component: () =>
            import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/dashCam/DashCam.vue")
      },
      {
        path: "photos",
        name: "vehiclePhotos",
        component: () =>
            import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/photos/VehiclePhotos")
      },
      {
        path: "documents",
        name: "vehicleDocuments",
        component: () =>
            import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/documents/VehicleDocuments")
      },
      {
        path: "comments",
        name: "vehicleComments",
        component: () =>
            import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/comments/VehicleComments")
      },
      {
        path: "inspections",
        name: "vehicleInspections",
        component: () =>
            import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/inspections/VehicleInspections")
      },

      {
        path: "issues",
        name: "vehicleIssues",
        component: () =>
            import(/* webpackChunkName: "issues" */ "@/modules/issues/components/ui/OverviewIssues")
      },

      {
        path: "faults",
        name: "vehicleFaults",
        component: () =>
            import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/faults/VehicleFaults")
      },

      {
        path: "reminders",
        name: "vehicleReminders",
        component: () =>
            import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/reminders/VehicleReminders")
      },

      {
        path: "serviceHistory",
        name: "vehicleServiceHistory",
        component: () =>
            import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/serviceHistory/VehicleServiceHistory")
      },

      {
        path: "fuelLog",
        name: "vehicleFuelLog",
        component: () =>
            import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/fuelLog/VehicleFuelLog")
      },

      {
        path: "assignmentHistory",
        name: "vehicleAssignmentHistory",
        component: () =>
            import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/assignmentHistory/VehicleAssignmentHistory")
      },

      {
        path: "odometerHistory",
        name: "vehicleOdometerHistory",
        component: () =>
            import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/odometerHistory/VehicleOdometerHistory")
      },

      {
        path: "locationHistory",
        name: "vehicleLocationHistory",
        component: () =>
            import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/layouts/locationHistory/VehicleLocationHistory")
      }
    ]
  },
  {
    path: "deviceForm",
    name: "deviceForm",
    component: () =>
        import(/* webpackChunkName: "vehicles" */ "@/modules/vehicles/components/forms/DeviceForm")
  },
  {
    path: "expenseForm",
    name: "expenseForm",
    component: () =>
        import(/* webpackChunkName: "expense" */ "@/modules/expense/components/forms/ExpenseForm")
  }
];
